import React from 'react'

const RestrictedArea = () => {
  return (
    <div>This section needs a logged in user!</div>
  )
}

export default RestrictedArea